
export const configData = {
    azureAd: {
        clientId: "e1346f20-eb43-4532-8fd7-ee2931e3f0b4",
        authority: "https://login.microsoftonline.com/abbvie.onmicrosoft.com/",
        validateAuthority: false,
        redirectUri: "https://localhost:4200",
        postLogoutRedirectUri: "https://localhost:4200",
        xredirectUri: "https://agnappdevcoolconnectweb.azurewebsites.net",
        xpostLogoutRedirectUri: "https://agnappdevcoolconnectweb.azurewebsites.net",
        navigateToLoginRequestUrl: false
    },
    appconfig: {
        instrumentationKey: '7835a0d5-d666-426a-a64e-123ed0ccf0f2'
    },
    apiURL: "https://localhost:5003/api/",
    scopeUri: "api://a426d3f8-669a-4595-a9c4-1d39d0f515f1/.default",
    fileUpload: {
        allowedFileTypes: ".zip,.zcipher",
        uploadApiUrl: "Upload",
        container: "installer"
      },      
      ioTManagement: {
        processLogFileFnApp: "agnfndeviotprocesslogfiles",
        releaseVersionCOM3:"3.3.0",
        releaseVersionCT:"3.3.0"
        }
}